import { Payout, PayoutItem } from "@wingspanhq/wingspan-api-sdk";
import { getPayoutNet } from "./utils";

export const getPayoutTotalAmount = (payout: Payout): number =>
  getPayoutNet(payout);

export const selectorIsPayoutItemVisible = (payoutItem: PayoutItem) =>
  payoutItem.sourceType === "Invoice" &&
  !payoutItem.description?.includes("Payout");
